module.exports = __webpack_public_path__ + "static/media/pickSwap.d52b5f5e.svg";